import {bus} from '../bus';

export default (title, text, scheduledFor) =>
  new Promise(resolve => {
    bus.emit('add-dynamic-overlay', {
      props: {
        title,
        scheduledFor,
        text,
      },
      component: 'tml-confirm-correspondence-popup',
      events: {
        confirm() {
          resolve(true);
        },
        cancel() {
          resolve(false);
        },
        'after-leave': () => {
          resolve(false);
        },
      },
    });
  });
